import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const NAV_LINKS = [
  { path: "/", label: "Home" },
  { path: "/menu", label: "Menu" },
  { path: "/reservations", label: "Reservations" },
  { path: "/events", label: "Events" },
  { path: "/catering", label: "Catering" },
  { path: "/franchise", label: "Franchise" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isHome = location.pathname === "/";
  const bg = scrolled || !isHome ? "bg-[#0B0B0F]/95 backdrop-blur-md border-b border-[#C9A227]/20" : "bg-transparent";

  return (
    <nav data-testid="main-navbar" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${bg}`}>
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 lg:h-20">
          <Link to="/" className="flex items-center shrink-0" data-testid="logo-link">
            <img src="https://customer-assets.emergentagent.com/job_937fb50f-6c1c-4cbe-8cbd-a98f08545350/artifacts/u5a3eo6l_PNG-05.png" alt="Sheesh" className="h-8 sm:h-10 lg:h-12 w-auto" />
          </Link>

          <div className="flex items-center gap-1 sm:gap-3 lg:gap-8 overflow-x-auto hide-scrollbar">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.label.toLowerCase()}`}
                className={`text-[11px] sm:text-xs lg:text-sm tracking-wide uppercase whitespace-nowrap px-1.5 sm:px-2 lg:px-0 py-1 transition-colors duration-200 ${
                  location.pathname === link.path ? "text-[#C9A227] font-semibold" : "text-white/70 hover:text-[#C9A227]"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}
